<div class="layout-content">
	<form [formGroup]="multiIOForm" class="grid">
		<div [class]="isIOMtma() ? '' : col12Responsive()" *ngIf="!isIOMtma()">
			<!-- <div class="col-12" *ngIf="!this.bistableEnabled"> 
				<div class="flex align-items-center justify-content-center p-1 border-round-xl bg-yellow-200">
					<p-tag icon="pi cm-alert" [value]="('PRESET_LABELS' | translate)" 
						severity="warning">
					</p-tag>
				</div>
			</div> -->
			<div class="col-12">
				<div class="flex justify-content-center align-items-center">
					<p-checkbox class="mr-2" [binary]="true" formControlName="bistable" value="true" (onChange)="toggleBistableParams($event.checked)"></p-checkbox>
					{{ 'COMMAND_TYPE' | translate }} {{ 'STATIC' | translate }}
				</div>
			</div>
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.stateActive, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.stateActive, 'label')">{{ 'STATE_ACTIVE' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.stateActive, 'borderInput')">
						<p-dropdown [options]="stateActiveOpt" formControlName="stateActive"
							[ngClass]="dynamicInputTextWidth()"
							styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
							id="edit-input-dialog-stateActive"
							placeholder="{{ 'STATE_ACTIVE' | translate }}">
							<ng-template let-item pTemplate="selectedItem">
								<div class="item flex align-items-center justify-content-center">
									<div class="flex align-items-center">{{ item.label | translate }}</div>
								</div>
							</ng-template>
							<ng-template let-item pTemplate="item">
								<div class="item flex justify-content-center">
									<div>{{item.label | translate }}</div>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.stateActive)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.commandActive, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.commandActive, 'label')">{{ 'COMMAND_LABEL_ACTIVE' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.commandActive, 'borderInput')">
						<input type="text" pInputText [maxLength]="36"
							[ngClass]="dynamicInputTextWidth()"
							formControlName="commandActive"
						/>
					</div>
				</div>
				<div class="flex align-items-center text-50" [ngClass]="justifyContentStyle()">
					<small *ngIf="showErrorRequiredMessage(this.f.commandActive)" class="pt-1">{{ 'REQUIRED' | translate }}</small>
					<!-- <small *ngIf="!showErrorRequiredMessage(this.f.commandActive) && (!underTablet())" class="pt-1_25rem"></small> -->
				</div>
			</div>
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.commandInactive, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.commandInactive, 'label')">{{ 'COMMAND_LABEL_INACTIVE' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.commandInactive, 'borderInput')">
						<input type="text" pInputText [maxLength]="36"
							[ngClass]="dynamicInputTextWidth()"
							formControlName="commandInactive"
						/>
					</div>
				</div>
				<div class="flex align-items-center text-50" [ngClass]="justifyContentStyle()">
					<small *ngIf="showErrorRequiredMessage(this.f.commandInactive)" class="pt-1">{{ 'REQUIRED' | translate }}</small>
					<!-- <small *ngIf="!showErrorRequiredMessage(this.f.commandInactive) && (!underTablet())" class="pt-1_25rem"></small> -->
				</div>
			</div>
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.activeState, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.activeState, 'label')">{{ 'ACTIVE_STATE_LABEL' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.activeState, 'borderInput')">
						<input type="text" pInputText [maxLength]="36"
							[ngClass]="dynamicInputTextWidth()"
							formControlName="activeState"
						/>
					</div>
				</div>
				<div class="flex align-items-center text-50" [ngClass]="justifyContentStyle()">
					<small *ngIf="showErrorRequiredMessage(this.f.activeState)" class="pt-1">{{ 'REQUIRED' | translate }}</small>
					<!-- <small *ngIf="!showErrorRequiredMessage(this.f.activeState) && (!underTablet())" class="pt-1_25rem"></small> -->
				</div>
			</div>
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.inactiveState, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.inactiveState, 'label')">{{ 'INACTIVE_STATE_LABEL' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.inactiveState, 'borderInput')">
						<input type="text" pInputText [maxLength]="36"
							[ngClass]="dynamicInputTextWidth()"
							formControlName="inactiveState"
						/>
					</div>
				</div>
				<div class="flex align-items-center text-50" [ngClass]="justifyContentStyle()">
					<small *ngIf="showErrorRequiredMessage(this.f.inactiveState)" class="pt-1">{{ 'REQUIRED' | translate }}</small>
					<!-- <small *ngIf="!showErrorRequiredMessage(this.f.inactiveState) && (!underTablet())" class="pt-1_25rem"></small> -->
				</div>
			</div>
		</div>

		<div [class]="isIOMtma() ? 'col-12 ' + customPaddingX() : col12Responsive()">
			<div class="col-12">
				<div class="flex justify-content-center align-items-center">
					<p-checkbox class="mr-2" [binary]="true" formControlName="timed" value="true" [readonly]="isIOMtma()" (onChange)="toggleTimedParams($event.checked)"
						[styleClass]="isIOMtma() ? 'p-checkbox-invalid' : ''"></p-checkbox>
					{{ 'COMMAND_TYPE' | translate }} {{ 'TIMED' | translate }}
				</div>
			</div>
			<div class="col-12" *ngIf="!isIOMtma()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-100" [ngClass]="newShowErrors(this.f.commandDuration, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.commandDuration, 'label')">{{ 'COMMAND_DURATION' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.commandDuration, 'borderInput')">
						<p-inputNumber formControlName="commandDuration" inputId="commandDuration-buttons" step="1"
							[useGrouping]="false" [maxFractionDigits]="0" [showButtons]="true" [min]="1" [max]="240"
							incrementButtonClass="p-0" decrementButtonClass="p-0 border-noround"
							inputStyleClass="pl-6 border-noround-right" [ngClass]="dynamicInputTextWidth()"
							[styleClass]="dynamicInputTextWidth()">
						</p-inputNumber>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.commandDuration)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.commandTimed, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.commandTimed, 'label')">{{ 'COMMAND_LABEL_TIMED' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.commandTimed, 'borderInput')">
						<input type="text" pInputText [maxLength]="36"
							[ngClass]="dynamicInputTextWidth()"
							formControlName="commandTimed"
						/>
					</div>
				</div>
				<div class="flex align-items-center text-50" [ngClass]="justifyContentStyle()">
					<small *ngIf="showErrorRequiredMessage(this.f.commandTimed)" class="pt-1">{{ 'REQUIRED' | translate }}</small>
					<!-- <small *ngIf="!showErrorRequiredMessage(this.f.commandTimed) && (!underTablet())" class="pt-1_25rem"></small> -->
				</div>
			</div>
		</div>
	</form>

	<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
		<button type="button" pButton pRipple
			label="{{ 'CONFIRM' | translate }}" (click)="submit()"
			class="p-button-primary text-xl font-normal mx-1 mb-2"
			[ngClass]="dynamicButtonWidth()">
		</button>
		<button type="button" pButton pRipple (click)="closeDialog()"
				label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mx-1 mb-2"
				[ngClass]="dynamicButtonWidth()">
		</button>
	</div>
</div>